import React, { MouseEvent, ReactElement } from "react";
import { GrFormClose } from "react-icons/gr";
import { RiArticleLine } from "react-icons/ri";
import useRouting, { Link } from "../../../contexts/Routing";
import { TicketMessageArticleInput } from "../../../__generated__/api";
import { HtmlRenderer } from "../../html-render/HtmlRenderer";

export default function ArticlePreview({
    article, onClose, className,
}: {
    article: TicketMessageArticleInput,
    onClose?: () => void;
    className?: string;
}): ReactElement {
    const { Paths } = useRouting();
    const handleClose = (evt: MouseEvent) => {
        evt.preventDefault();
        onClose?.();
    };
    return (
        <div
            className={`border rounded p-2 ${className}`}
        >
            <div className="d-flex justify-content-between align-items-center">
                <Link
                    to={Paths.ANSWERS_GET}
                    params={{ id: article.id }}
                    target="_blank"
                    rel="noreferrer"
                    className="text-decoration-none text-secondary"
                >
                    <RiArticleLine className="mx-0 me-2 text-light-300" />
                    <span>{article.title}</span>
                </Link>
                {onClose && (
                    <button type="button" onClick={handleClose} className="btn btn-none">
                        <GrFormClose />
                    </button>
                )}

            </div>
            <small>
                <HtmlRenderer html={article.previewText ?? ""} />
            </small>

        </div>
    );
}
ArticlePreview.defaultProps = {
    className: "",
    onClose: undefined,
};
